import { useMemo } from 'react';
import {
  Clock,
  Calendar,
  DollarSign,
  CreditCard,
} from 'lucide-react';

/**
 * Employee Quick Actions for the dashboard FAB.
 * Admin portal does not use a FAB (desktop-first; actions live in the sidebar).
 *
 * @param {boolean} _isAdmin - Deprecated; admin FAB removed. Ignored.
 * @param {number} _pendingDocumentsCount - Deprecated; ignored.
 * @param {Object} options - Additional options
 * @param {Function} options.onOpenNameCard - Callback to open name card overlay
 * @param {string} options.classification - Employee classification for gating
 * @returns {Array} Array of quick action objects
 */
export const useQuickActions = (_isAdmin = false, _pendingDocumentsCount = 0, options = {}) => {
  const { onOpenNameCard, classification } = options;

  return useMemo(() => {
    const NAME_CARD_CLASSIFICATIONS = ['staff', 'executive_director', 'managing_director'];

    // Employee quick actions — Petty Cash goes via /petty-cash so probation
    // staff see the Clause 8 dental advisory before SSO handoff.
    return [
      {
        title: 'Clock In/Out',
        description: 'Track your attendance',
        icon: Clock,
        color: 'green',
        link: '/attendance',
      },
      {
        title: 'Apply Leave',
        description: 'Submit a new leave request',
        icon: Calendar,
        color: 'blue',
        link: '/leave/apply',
      },
      {
        title: 'Submit Petty Cash Claim',
        description: 'Submit expense reimbursement',
        icon: DollarSign,
        color: 'teal',
        link: '/petty-cash',
      },
      ...(onOpenNameCard && NAME_CARD_CLASSIFICATIONS.includes(classification) ? [{
        title: 'My Name Card',
        description: 'Share your digital name card',
        icon: CreditCard,
        color: 'indigo',
        action: onOpenNameCard,
      }] : []),
    ];
  }, [onOpenNameCard, classification]);
};
